TS.ns('WL');

WL.partnerScoringModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);

        var engineScoring = me.getDomainProperty('ScoringEngineList');
        if (engineScoring) {
            engineScoring.on('selectionChanged', me.onEngineScoringChanged, me);
        }
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var financialInd = me.getDomainProperty('FinancialIndicatorsProperty');

        if (financialInd != null) {

            financialInd.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);

                        if (dataItem.StyleId == WL.Config.DictionaryFinancialIndicatorStyle.Bold) {
                            row.addClass("scoring_financialIndicator_bold_row");
                        }

                        if (dataItem.StyleId == WL.Config.DictionaryFinancialIndicatorStyle.Bold_Red) {
                            row.addClass("scoring_financialIndicator_bold_red_row");
                        }

                        if (dataItem.StyleId == WL.Config.DictionaryFinancialIndicatorStyle.Italic) {
                            row.addClass("scoring_financialIndicator_italic_row");
                        }
                    }
                }
            }

            cat = financialInd.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'SelectIndicatorDimension';
            newCmd['Text'] = me.SelectIndicatorDimensionCommandText;
            newCmd['handler'] = '_selectIndicatorDimension';
            newCmd['IconCode'] = 'ellipsis-v';

            cat.push(newCmd);
        }

        var gridCategory = me.getDomainProperty('dgPartnerScoringData_Property');

        if (gridCategory != null) {
            gridCategory.on('cellBeginEdit', me.onScoringCategoryCellEdit);
            gridCategory.on('cellValueChanged', me.onOptionOrUserValueChanged);

            gridCategory.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        if (dataItem.ReadOnlyCategory == true) {
                            row.addClass("grey_readonly_scoring_category");
                        }
                    }
                }
            }
        }
    },

    onOptionOrUserValueChanged: function (e) {
        var me = this,
            rec = e.item,
            owner = me._getOwner(),
            categoryList = owner.getDomainProperty('dgPartnerScoringData_Property');

        if (e.fieldName == 'UserValue') {
            owner.performServerCommand({
                cmd: 'UpdateScoringCategoryOptionOrValue',
                submitModel: true,
                extraData: {
                    IsUserValueModified: true,
                    ScoringCategoryId: categoryList.SelectedItem().ScoringId(),
                    ScoringCategoryDetailId: categoryList.SelectedItem().ScoringDetailId(),
                    UserValue: categoryList.SelectedItem().UserValue()
                },
                blockUI: true
            });
        }

        if (e.fieldName == 'ScoringDetailId' && categoryList.SelectedItem().InputTypeId() == WL.Config.ScoringCategoryInputType.NUMERIC) {
            owner.performServerCommand({
                cmd: 'UpdateScoringCategoryOptionOrValue',
                submitModel: true,
                extraData: {
                    IsUserValueModified: false,
                    ScoringCategoryId: categoryList.SelectedItem().ScoringId(),
                    ScoringCategoryDetailId: categoryList.SelectedItem().ScoringDetailId(),
                    UserValue: categoryList.SelectedItem().UserValue()
                },
                blockUI: true
            }); 
        }
    },

    onScoringCategoryCellEdit: function (e) {
        var me = this,
            owner = me._Domain,
            categoryList = owner.getDomainProperty('dgPartnerScoringData_Property');

        if (e.fieldName == 'ScoringDetailId' && categoryList.SelectedItem().ReadOnlyCategory())
            e.preventDefault();

        if (e.fieldName == 'UserValue' && (categoryList.SelectedItem().InputTypeId() == WL.Config.ScoringCategoryInputType.SELECTION_LIST || categoryList.SelectedItem().ReadOnlyCategory()))
            e.preventDefault();
    },

    onEngineScoringChanged: function (selectedRecord) {
        var me = this; 

        me.performServerCommand({
            cmd: 'LoadEngineScoringClassification',
            submitModel: true, 
            extraData: {
                EngineScoringId: selectedRecord.sender.SelectedItem().Key
            }, 
            blockUI: true 
        });
    },

    _selectIndicatorDimension: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'SelectIndicatorDimension',
            submitModel: true,
            blockUI: false
        });
    }
});